import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            isMobileSize: 'isMobileSize',
            projectsList: 'projectsList',
            isTypeMobile: 'isTypeMobile',
            isTypeTablet: 'isTypeTablet',
            deviceOrientation: 'deviceOrientation'
        }),
        portraitMode() {
            return (this.isTypeMobile || this.isTypeTablet) && this.deviceOrientation === 'portrait'
        }
    },
    methods: {
        domPreloader() {
            let route = this.$route.matched.length
                ? this.$route.matched[this.$route.matched.length - 1]
                : false

            if (
                route &&
                route.components.default.name === this.$options.name &&
                route.meta.preload
            ) {
                this.$store.dispatch('stopPreloading', 'dom')
            }
        }
    },
    activated() {
        this.domPreloader()
    },
    mounted() {
        this.domPreloader()
    }
}
